import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * tailwind-merge has to know the design system's own scales (styles.css). Left
 * to its defaults it reads `text-14` as a colour, so `cn('text-14',
 * 'text-muted-foreground')` would drop the size, and it cannot tell that
 * `rounded-card` and `rounded-control` are the same property.
 */
const merge = extendTailwindMerge({
    override: {
        theme: {
            color: [
                'background',
                'foreground',
                'card',
                'card-foreground',
                'popover',
                'popover-foreground',
                'muted',
                'muted-foreground',
                'subtle-foreground',
                'accent',
                'accent-foreground',
                'primary',
                'primary-foreground',
                'primary-hover',
                'primary-subtle',
                'primary-strong',
                'primary-button',
                'primary-button-foreground',
                'primary-button-border',
                'primary-button-hover',
                'success',
                'success-subtle',
                'success-strong',
                'warning',
                'warning-subtle',
                'warning-strong',
                'destructive',
                'destructive-subtle',
                'destructive-strong',
                'info',
                'info-subtle',
                'info-strong',
                'border',
                'border-strong',
                'input',
                'ring',
                'overlay',
                'star',
                'header',
                'header-foreground',
            ],
            text: ['11', '12', '13', '14', '15', '16', '18', '20', '22', '24', '28', '32', '40', '48', '56', '64'],
            radius: ['badge', 'control', 'card', 'overlay', 'inner'],
            shadow: ['popover', 'overlay'],
            tracking: ['normal', 'hero', 'title', 'section', 'heading', 'data', 'label'],
            'font-weight': ['normal', 'medium', 'semibold'],
        },
    },
    // The numeric spacing scale stays Tailwind's; a shop's density adds two names to it.
    extend: {
        theme: {
            spacing: ['card-pad', 'grid-gap'],
        },
    },
});

/** Joins class names and lets a later class override an earlier one of the same kind. */
export function cn(...inputs: ClassValue[]): string {
    return merge(clsx(inputs));
}
